exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".loading_modal_2uiej {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    margin-top: -20px;\n    margin-left: -30px;\n    background: rgb(255, 255, 255);\n    overflow: auto;\n    border-radius: 4px;\n    outline: none;\n    padding: 20px;\n}\n.loading_overlay_VH7qY {\n    position: fixed;\n    inset: 0px;\n    background-color: rgba(255, 255, 255, 0.75);\n    z-index: 1000000;\n}\n", ""]);

// exports
exports.locals = {
	"modal": "loading_modal_2uiej",
	"overlay": "loading_overlay_VH7qY"
};